<dx-data-grid #gridVarianti >
   <dxi-column dataField="" caption="" cellTemplate="optionTemplate" width="75"></dxi-column>
   <dxo-header-filter [visible]="true"></dxo-header-filter>

   <div *dxTemplate="let cellInfo of 'optionTemplate'">
      <a
         class="btn-tbl icon-modifica"
         tabindex="0"
         role="button"
         (click)="clickOpenVariantPage(cellInfo)"
         (keydown.enter)="clickOpenVariantPage(cellInfo)"
         (keydown.space)="$event.preventDefault(); clickOpenVariantPage(cellInfo)">
      </a>
   </div>
   <dxi-column dataField="" width="100" cellTemplate="imgTemplate" caption="Immagine" cssClass=""></dxi-column>
   <div *dxTemplate="let cellInfo of 'imgTemplate'" class="text-center">
      <img *ngIf="cellInfo.data.img_variant" [src]="cellInfo.data.img_variant" alt="immagine prodotto"
           width="85" class="inline-block">
   </div>
   <dxi-column *ngIf="isShop" dataField="is_enabled" caption="Sync" cellTemplate="syncTemplate" alignment="center" width="100px" dataType="boolean"
               [allowHeaderFiltering]="true" [allowFiltering]="false">
      <dxo-header-filter
         [dataSource]="headerFilterSync">
      </dxo-header-filter>
   </dxi-column>
   <div *dxTemplate="let cellInfo of 'syncTemplate'">

      <div *ngIf="cellInfo.data.is_sync && !cellInfo.data.is_enabled">
         <span class="h-[15px] w-[15px] bg-gray-600 rounded-2xl inline-block"
               matTooltip="Prodotto disattivato per la sincronizzazione"
               [matTooltipPosition]="'right'">
         </span>
      </div>
      <div *ngIf="!cellInfo.data.is_sync && !cellInfo.data.is_enabled">
         <span class="h-[15px] w-[15px] bg-red-600 rounded-2xl inline-block"
               matTooltip="Prodotto non abilitato alla sincronizzazione"
               [matTooltipPosition]="'right'">
      </span>
      </div>
      <div *ngIf="cellInfo.data.is_sync && cellInfo.data.is_enabled && !cellInfo.data.has_ext_id">
         <span class="h-[15px] w-[15px] bg-yellow-500 rounded-2xl inline-block"
               matTooltip="Prodotto abilitato alla sincronizzazione"
               [matTooltipPosition]="'right'">
         </span>
      </div>
      <div *ngIf="cellInfo.data.is_sync && cellInfo.data.is_enabled && cellInfo.data.has_ext_id">
         <span class="h-[15px] w-[15px] bg-green-600 rounded-2xl inline-block"
               matTooltip="Prodotto sincronizzato sullo store"
               [matTooltipPosition]="'right'">
         </span>
      </div>
   </div>

   <dxi-column dataField="qta_tot" caption="Qta" width="100px" [allowHeaderFiltering]="false" [allowFiltering]="false" [allowSearch]="false"> </dxi-column>
   <dxi-column dataField="qta_instance_gt_0" caption="Numero varianti" width="100px" [allowHeaderFiltering]="false" [allowFiltering]="false" [allowSearch]="false"> </dxi-column>

   <dxi-column caption="Info Prodotto">
      <dxi-column dataField="brand" caption="Brand"  [allowHeaderFiltering]="false" [allowFiltering]="true"></dxi-column>
      <dxi-column dataField="prodotto.nome" caption="Nome" cssClass="whitespace-normal" [allowHeaderFiltering]="false" [allowFiltering]="true"></dxi-column>
      <dxi-column dataField="prodotto.stagione" caption="Stagione"  cellTemplate="stagTemplate" [allowHeaderFiltering]="true" [allowFiltering]="true">
         <dxo-header-filter
            [dataSource]="headerFilterStagioneData">
         </dxo-header-filter>
      </dxi-column>
      <div *dxTemplate="let cellInfo of 'stagTemplate'">
         <div *ngFor="let st of Prodotto.STAGIONI">
            <span *ngIf="st.value == cellInfo.data.prodotto.stagione">{{st.display}}</span>
         </div>
      </div>
      <dxi-column dataField="prodotto.year" caption="Anno" dataType="number"  [allowHeaderFiltering]="false" [allowFiltering]="true"></dxi-column>
   </dxi-column>

   <dxi-column caption="Info Variante">
      <dxi-column dataField="colore_nome" caption="Colore"  [allowHeaderFiltering]="false" [allowFiltering]="true"></dxi-column>
      <dxi-column dataField="codice" caption="Codice"  [allowHeaderFiltering]="false" [allowFiltering]="true"></dxi-column>
      <dxi-column dataField="desc_colore" caption="Descrizione Colore" [allowHeaderFiltering]="false" [allowFiltering]="true"></dxi-column>
   </dxi-column>
</dx-data-grid>

<app-popup-generic [(visible)]="popupSync"
                   [content]="popupContent"
                   [mode]="'normal'"
                   [width]="'500'"
                   [height]="'500'"
                   [buttons]="popupTermsButtons"
                   [title]="'Abilita Sync Prodotti'"
></app-popup-generic>

<ng-template #popupContent>
   <div class="text-center mt-3 leading-4	">
<!--      <div class="text-2xl">Varianti selezionate: {{itemsCount}}</div>-->

      <div class="my-5 px-2">
         <button class="ds-btn ds-btn-info w-full mb-5 pr-0" (click)="clickSyncShop(1)">Abilita Sincronizzazione</button>
         <button class="ds-btn ds-btn-error w-full mb-3" (click)="clickSyncShop(0)">Disabilita Sincronizzazione</button>
      </div>

   </div>
</ng-template>

<ng-template #templateVariant>
   <app-template-variants [vendorSlug]="vendorSlug" [colorId]="colorId" [prodottoId]="prodottoId" [productVariant]="productVariant" [pVarianteId]="pVarianteId"></app-template-variants>
</ng-template>
